module.exports = __webpack_public_path__ + "static/img/product-3.2e1d906.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product-3.png
// module id = woRu
// module chunks = 0